// AppRouter.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import { HelpPage } from './components/help';
import { LegalHub, PrivacyPolicy, TermsOfService } from './components/legal';

import SubscriptionSuccessWrapper from './components/SubscriptionSuccessWrapper';
import Tutorials from './components/tutorials/Tutorials';

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path="/help/*" element={<HelpPage />} />
                <Route path="/legal" element={<LegalHub />} />
                <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/legal/terms-of-service" element={<TermsOfService />} />
                <Route path="/reset-password" element={<App />} />
                <Route path="/login" element={<App />} />
                <Route path="/sign-up" element={<App />} />
                <Route path="/premium" element={<App />} />
                <Route path="/weekly" element={<App />} />
                <Route path="/community" element={<App />} />
                <Route path="/style-codes" element={<App />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route path="/tutorials/:tutorialSlug" element={<Tutorials />} />
                <Route path="/subscription-success" element={<SubscriptionSuccessWrapper />} />
                <Route path="/" element={<App />} />
               
            </Routes>
        </Router>
    );
};

export default AppRouter;